import axiosInstance from '../utils/axiosInstance';
import { DebtConsolidationFeaturesResponse } from './types';

export const getFeatures = async () => {
  const response = await axiosInstance.get<DebtConsolidationFeaturesResponse>(
    '/debt-consolidation/features-steps'
  );
  return response.data;
};
